import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch } from "react-redux";
import { FaUser, FaLock, FaEye, FaEyeSlash, FaArrowRight } from "react-icons/fa";
import { loginUser } from "../../features/userSlice";
import logo from "../../assets/grouplogo.png";
import "./LoginScreen.css";

const LoginScreen = () => {
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [emp_id, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error1, setError] = useState(false);
  const [spinloading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [menuOptions, setMenuOptions] = useState([]);

  useEffect(() => {
    if (isLoggedIn) {
      const fetchMenuOptions = async () => {
        try {
          const menuResponse = await axios.post("/api/menu/getMenuUserData", { emp_id });
          setMenuOptions(menuResponse.data);
        } catch (error) {
          console.error("Error fetching menu options:", error);
        }
      };
      fetchMenuOptions();
    }
  }, [isLoggedIn, emp_id]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setError(false);
    setLoading(true);

    const userCredentials = { emp_id, password };

    try {
      const result = await dispatch(loginUser(userCredentials));

      if (result.payload) {
        setIsLoggedIn(true);
        setEmail("");
        setPassword("");
        navigate("/dashboard");
      } else {
        setShowErrorModal(true);
        setError(true);
      }
    } catch (error) {
      setShowErrorModal(true);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg" aria-hidden="true" />

      <main className="login-shell">
        <section className="login-panel">
          <div className="login-brand">
            <img src={logo} alt="Singhal Logistics" className="login-logo" />
            <p className="login-brand-name">Singhal Logistics</p>
            <p className="login-brand-sub">Yard & Weighbridge Operations</p>
          </div>

          <h1 className="login-title">Sign in</h1>
          <p className="login-support">Enter your User ID and password to continue.</p>

          {error1 && (
            <div className="login-inline-error" role="alert">
              Invalid User ID or Password
            </div>
          )}

          {!isLoggedIn ? (
            <form onSubmit={submitHandler} className="login-form" noValidate>
              <label className="login-field">
                <span>User ID</span>
                <div className="login-input-wrap">
                  <FaUser className="login-input-icon" aria-hidden="true" />
                  <input
                    type="text"
                    value={emp_id}
                    placeholder="Enter your user ID"
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="username"
                    required
                  />
                </div>
              </label>

              <label className="login-field">
                <span>Password</span>
                <div className="login-input-wrap">
                  <FaLock className="login-input-icon" aria-hidden="true" />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    placeholder="Enter your password"
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <button
                    type="button"
                    className="login-eye-btn"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </label>

              <button type="submit" className="login-submit" disabled={spinloading}>
                {spinloading ? "Signing in..." : "Sign in"}
                {!spinloading && <FaArrowRight aria-hidden="true" />}
              </button>

              <button
                type="button"
                className="login-forgot"
                onClick={() => navigate("/resetPassword")}
              >
                Forgot Password?
              </button>
            </form>
          ) : (
            <div className="menu-tiles-container">
              {menuOptions.map((menu, index) => (
                <Link key={index} to={menu.url} className="menu-tile-link">
                  {menu.name}
                </Link>
              ))}
            </div>
          )}
        </section>
      </main>

      <footer className="login-footer">© {new Date().getFullYear()} Singhal Group | All Rights Reserved.</footer>

      {showErrorModal && (
        <div className="login-modal-backdrop" onClick={() => setShowErrorModal(false)}>
          <div
            className="login-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="login-error-title"
          >
            <h2 id="login-error-title">Login Error</h2>
            <p>Invalid User ID or Password. Please try again.</p>
            <button type="button" className="login-submit" onClick={() => setShowErrorModal(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginScreen;
